/**
 *
 * App.react.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React from 'react';

export default props => (
  <div>
    {props.children}
  </div>
);



// WEBPACK FOOTER //
// ./book/src/commons/components/App.jsx